import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import NavLink from 'react-router-dom/NavLink';
import {
    DeleteDeposit,
    DoDeposit,
    DoQuestion,
    GetDepositList,
    GetEventList,
    getExchangeInfo,
    getBonusList,
   
} from "../../common/actions/moreAction";
import {
    convertDepositString,
    convertStyle,
    dateFormation,
    isEmpty,
    isMobilePage,
    moneyValues,
    no_comma,
    toastr
} from "../../common/cores";

import Pagenation from '../common/Pagenation';

const getMoneySetting = (data) => {
    return data;
}

const MainContent = (props) => {

    const exchangeSetting = props.exchangeSetting
    const setMoneySetting = useMemo(() => getMoneySetting(exchangeSetting), [exchangeSetting]);
    const minMoney = !isEmpty(setMoneySetting) ? setMoneySetting.charge_min_money.toLocaleString() : "10,000";
    const chargeUnit = !isEmpty(setMoneySetting) ? setMoneySetting.charge_unit : 1000;
    const [money, setMoney] = useState(0);
    const [showHis, setShowHis] = useState(false);
    const [depositBonusShow, setDepositBonusShow] = useState(false);
    const [depositBonus, setDepositBonus] = useState(null);
    const [depositBonusTitle, setDepositBonusTitle] = useState("선택시 포인트미지급");

    const { page, user, bonusList } = props;
    const [ids, setIds] = useState([]);
    const [accountInfo, setAccountInfo] = useState({});

    const getLists = (page) => {
        props.GetDepositList("deposit", page);
        props.getBonusList();
    }
    // console.log(user)

    // useEffect(() => {
    //     props.GetExchangeSetting();
    // }, [])

    const onChange = (e) => {
        const { value, checked } = e.target; // 우선 e.target 에서 name 과 value 를 추출
        // console.log(value, checked)
        if (checked) setIds([...ids, value]);
        else setIds(ids.filter(item => item !== value))
        // console.log(ids);
        // console.log(isNaN(Number(value)))
        if (!isNaN(Number(no_comma(value)))) setMoney(Number(no_comma(value)));
        else setMoney(0);
    };

    useEffect(() => {
        getLists(1);
    }, [props.page.perPage])

    useEffect(() => {
        props.getBonusList();
        if (!isEmpty(bonusList)) {
            setDepositBonus(bonusList[0]._id)
            setDepositBonusTitle(bonusList[0].name)
        }
    }, [bonusList.length])

    const reset = () => {
        setMoney(0);
    }

    const historyDelete = (value) => {
        console.log(value);
        props.DeleteDeposit({
            ids,
            all: value,
            typeStr: 'deposit'
        });
        setIds([]);
    }
    const moneyValues = [
        {
            value: 10000,
        },
        {
            value: 30000,
        },
        {
            value: 50000,
        },
        {
            value: 100000,
        },
        {
            value: 500000,
        },
        {
            value: 1000000,
        },
        {
            value: 5000000,
        },
        {
            value: 10000000,
        },
    ]

    const showHisotry = () => {
        setShowHis(!showHis);
    }
    const getMoneyFormat = (val) => {
        let res = "";
        if (val / 10000 > 0)
            res += (val / 10000) + "만원"
        val = val % 10000;
        if (val / 1000 > 0)
            res += (val / 1000) + "천원"
        val = val % 1000;
        if (val / 100 > 0)
            res += (val / 100) + "백원"
        val = val % 100;
        if (val / 10 > 0)
            res += (val / 10) + "십원"
        val = val % 10;
        if (val != 0)
            res += val
        return res
    }


    const onBonus = val => {
        setDepositBonus(val);
      };

    const onDeposit = () => {
        if (money <= 0) {
            return toastr.warning("머니를 입력해주세요.");
        }
        else if (money < minMoney) {
            return toastr.warning(`${minMoney}이상으로만 가능합니다.`)
        }
        let depositMoney = Math.floor(money / chargeUnit) * chargeUnit;
        const { secretKey } = accountInfo;
        props.DoDeposit(depositMoney, "deposit", "", depositBonus, secretKey);
    };

    return (
        <div className="contents_wrap">
            <div className="contents_box">
                <div className="con_box00">
                    <div className="tab_wrap">
                        <ul>
                            <li><NavLink to="/deposit"><span className="tab">충전신청</span></NavLink></li>
                            <li><NavLink to="/deposit/details"><span className="tab">충전내역</span></NavLink></li>

                        </ul>
                    </div>
                </div>
                <div className="con_box10">
                    <div className="info_wrap">
                        <div className="info1"><span className="info_title1">확인 / 주의사항</span></div>
                        <div className="info2">입금계좌를 통해 머니로 충전합니다.</div>
                        <div className="info3">

                            <img src="images/dot.jpg" className="dot" /> <span className="font05">입금하실 시, 예금주명은 회원님 성함으로 필히 입금바랍니다.</span><br />
                            <img src="images/dot.jpg" className="dot" /> 은행 점검시간을 확인하신 후 해당시간에는 <span className="font11">입금이 지연될 수 있으니 점검시간을 피해</span> 신청해 주시기 바랍니다.<br />
                            <img src="images/dot.jpg" className="dot" /> 입금계좌는 수시로 변경되오니 반드시 <span className="font12">계좌번호문의 신청을 통해 계좌번호를 확인 후 입금</span>하여 주시기 바랍니다.<br />
                            <img src="images/dot.jpg" className="dot" /> 자세한 문의사항은 고객센터(1:1문의)를 이용해 주시기 바랍니다.<br />
                        </div>
                    </div>
                </div>
                <div className="con_box10">
                    <div className="info_wrap">
                        <div className="info1"><span className="info_title1">입금 계좌 정보확인</span></div>
                        <div className="info3">
                            <img src="images/dot.jpg" className="dot" /> 입금 계좌번호는 쪽지로 발송되며, 계좌번호로 선 입금 바랍니다.
                        </div>
                    </div>
                </div>
                <div className="con_box10">
                    <div className="write_wrap">
                        <div className="write1"><span className="info_title2">충전금액 입력</span></div>
                        {!isMobilePage() &&
                            <div className="write3">
                                <table width="100%" border="0" cellSpacing="0" cellPadding="0" className="write_title_top">
                                    <tbody>
                                        <tr>
                                            <td className="write_title">현재 보유금액</td>
                                            <td className="write_basic"><span className="font14">{!isEmpty(user.data.balance) ? Number(user.data.balance.money).toLocaleString() : 0}</span>원</td>
                                        </tr>
                                        <tr>
                                            <td className="write_title">충전금액</td>
                                            <td className="write_basic">
                                                <input
                                                    data-v-5b7f4dd8="" data-v-216d8a58="" type="text" placeholder="입금하실 금액을 입력해주세요"
                                                    inputMode="numeric" className="input1"
                                                    style={{ backgroundColor: "upset", textAlign: "left" }}
                                                    value={Number(money).toLocaleString()}
                                                    onChange={onChange}
                                                />
                                                <br /><br />
                                                {
                                                    moneyValues.map((item, index) => {
                                                        return (
                                                            <a key={index} >  <span className="btn1_2" style={{ marginRight: "4px" }} onClick={() => setMoney(money + item.value)}>{getMoneyFormat(item.value)}</span></a>
                                                        )
                                                    })
                                                }
                                                <a ><span className="btn1_1" onClick={() => setMoney(0)} style={{ marginRight: "4px" }}>정정</span></a></td>
                                        </tr>
                                        <tr>
                                            <td class="write_title">보너스선택</td>
                                            <td className="write_basic" style={{ float: "left" }}>
                                                <div className="font21">
                                                    <input type="checkbox" id="ck_no_bonus" className="input_check_1_bonus" checked={depositBonus === null} />
                                                    <label for="ck_no_bonus" onClick={() => onBonus(null)}>선택시 포인트미지급</label>
                                                </div>
                                                {
                                                    !isEmpty(bonusList) && bonusList.map((item, index) => {
                                                        return (
                                                            <div className="custom-deposit-bonus" key={index}>
                                                                <input type="checkbox" id="ck_no_bonus" className="input_check_1_bonus" checked={item._id === depositBonus} />
                                                                <label for="ck_no_bonus" onClick={() => onBonus(item._id)} style={{ color: `${item.name_color}` }}>{item.name}</label>
                                                                <div style={{ color: `${item.help_color}`, marginTop: "10px", padding: "0 0 0 30px", display: "flex", fontSize: "14px" }}>
                                                                    {item.help}
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        }
                        {isMobilePage() &&
                            <div className="write3">
                                <table width="100%" border="0" cellSpacing="0" cellPadding="0" className="write_title_top">
                                    <tbody>
                                        <tr>
                                            <td className="write_title" style={{ width: "30%" }}>현재 보유금액</td>
                                            <td className="write_basic"><span className="font14">{!isEmpty(user.data.balance) ? Number(user.data.balance.money).toLocaleString() : 0}</span>원</td>
                                        </tr>
                                        <tr>
                                            <td className="write_title" style={{ width: "30%" }}>충전금액</td>
                                            <td className="write_basic">
                                                <input
                                                    data-v-5b7f4dd8="" data-v-216d8a58="" type="text" placeholder="입금하실 금액을 입력해주세요"
                                                    inputMode="numeric" className="input1"
                                                    style={{ width: "100%", backgroundColor: "upset", textAlign: "left" }}
                                                    value={Number(money).toLocaleString()}
                                                    onChange={onChange}
                                                />
                                                <table width="100%" border="0" align="center" cellSpacing="2" cellPadding="0">
                                                    <tbody>
                                                        <tr>
                                                            <td width="10%" align="center"><a><span className="m_btn1_2" onClick={() => setMoney(money + 10000)}>1만원</span></a></td>
                                                            <td width="10%" align="center"><a ><span className="m_btn1_2" onClick={() => setMoney(money + 30000)}>3만원</span></a></td>
                                                            <td width="10%" align="center"><a><span className="m_btn1_2" onClick={() => setMoney(money + 50000)}>5만원</span></a></td>
                                                        </tr>
                                                        <tr>
                                                            <td width="10%" align="center"><a><span className="m_btn1_2" onClick={() => setMoney(money + 100000)}>10만원</span></a></td>
                                                            <td width="10%" align="center"><a><span className="m_btn1_2" onClick={() => setMoney(money + 500000)}>50만원</span></a></td>
                                                            <td width="10%" align="center"><a><span className="m_btn1_2" onClick={() => setMoney(money + 1000000)}>100만원</span></a></td>
                                                        </tr>
                                                        <tr>
                                                            <td width="10%" align="center"><a><span className="m_btn1_2" onClick={() => setMoney(money + 5000000)}>500만원</span></a></td>
                                                            <td width="10%" align="center"><a><span className="m_btn1_2" onClick={() => setMoney(money + 10000000)}>1000만원</span></a></td>
                                                            <td width="10%" align="center"><a><span className="m_btn1_1" onClick={() => setMoney(0)}>정정</span></a></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>

                                        <tr>
                                            <td class="write_title">보너스선택</td>
                                            <td className="write_basic" style={{ float: "left" }}>
                                                <div className="font21">
                                                    <input type="checkbox" id="ck_no_bonus" className="input_check_1_bonus" checked={depositBonus === null} />
                                                    <label for="ck_no_bonus" onClick={() => onBonus(null)}>선택시 포인트미지급</label>
                                                </div>
                                                {
                                                    !isEmpty(bonusList) && bonusList.map((item, index) => {
                                                        return (
                                                            <Fragment>
                                                                <div className="custom-deposit-bonus" key={index}>
                                                                    <input type="checkbox" id="ck_no_bonus" className="input_check_1_bonus" checked={item._id === depositBonus} />
                                                                    <label for="ck_no_bonus" onClick={() => onBonus(item._id)} style={{ color: `${item.name_color}` }}>{item.name}</label>
                                                                    <div style={{ color: `${item.help_color}`, padding: "0 0 0 30px", display: "flex", fontSize: "14px", marginTop: "10px" }}>{item.help}</div>
                                                                </div>

                                                            </Fragment>
                                                        )
                                                    })
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        }
                    </div>
                </div>
                <div className="con_box30">
                    <div className="btn_wrap_center">
                        <ul>
                            <li><a onClick={onDeposit}><span className="btn3_1" >입금신청하기</span></a></li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>

    );
};

const mapStateToProps = state => ({
    user: state.user,
    deposit: state.more.deposit,
    page: state.page,
    bonusList: state.more.bonusList,
    exchangeSetting: state.more.exchangeSetting
})

export default connect(mapStateToProps, { GetDepositList, DoDeposit, DeleteDeposit, getExchangeInfo, DoQuestion, getBonusList })(MainContent);


// WEBPACK FOOTER //
// ./src/components/account/depositContent.js